// removed by extract-text-webpack-plugin
module.exports = {"containerSummary":"styles__containerSummary___cBZTM"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/DataQuota/styles.css
// module id = 3139
// module chunks = 0